import React from 'react';
import { Link } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';
import AppButton from '../../styles/common/AppButton';
import { PAGE_PATH, REMOTE_COMMAND } from '../../lib/constants';
import callImage from '../../images/common/call_white_24dp.svg';
import {
  Main,
  Table,
  Thead,
  TheadTr,
  Tbody,
  TbodyTr,
  ScrolledBody,
  DateCell,
  ParticipantsCell,
  ButtonCell,
  CenteredButtonWrapper,
  ButtonImage,
} from './styles/CallHistoryListsStyles';
import { convertISOFormatToDate } from '../../lib/tools';

/**
 * 通話履歴のリストを表示するコンポーネント。
 * @returns
 */
const CallHistoryLists = () => {
  const callHistories = useSelector(state => state.remote.callHistories);
  const userInfo = useSelector(state => state.main.userInfo);

  // 通話履歴から自分自身を除外する
  const filteredHistories = callHistories.map(history => ({
    ...history,
    members: history.members.filter(
      member => member.id !== userInfo.operatorId,
    ),
  }));

  return (
    <Main>
      <Table>
        <Thead>
          <TheadTr>
            <th scope="col" colSpan={1}>
              <p style={{ paddingLeft: '8px' }}>
                <FormattedMessage id="operator.callHistory.date" />
              </p>
            </th>
            <th scope="col" colSpan={3}>
              <FormattedMessage id="operator.callHistory.participant" />
            </th>
          </TheadTr>
        </Thead>
      </Table>
      <ScrolledBody>
        <Table>
          <Tbody>
            {filteredHistories.map(history => {
              const operatorIdsStr = JSON.stringify(
                history.members.map(member => member.id),
              );

              return (
                <TbodyTr key={history.id}>
                  <DateCell>
                    {convertISOFormatToDate(history.startedAt)}
                  </DateCell>
                  <ParticipantsCell>
                    {history.members.map(member => member.name).join(', ')}
                  </ParticipantsCell>
                  <ButtonCell>
                    <CenteredButtonWrapper>
                      <Link
                        target="_blank"
                        to={`${PAGE_PATH.DS_REMOTE}/pre/${REMOTE_COMMAND.caller}?operatorIds=${operatorIdsStr}`}
                      >
                        <AppButton className="button" small>
                          <ButtonImage src={callImage} alt="call" />
                          <FormattedMessage id="operator.dashboard.remote.call" />
                        </AppButton>
                      </Link>
                    </CenteredButtonWrapper>
                  </ButtonCell>
                </TbodyTr>
              );
            })}
          </Tbody>
        </Table>
      </ScrolledBody>
    </Main>
  );
};
export default CallHistoryLists;
